import { ref } from "vue";

const openId = ref(null);

export function useToggleAll() {
  const isOpen = (id) => openId.value === id;

  const toggle = (id) => {
    if (openId.value === id) {
      openId.value = null;
    } else {
      openId.value = id;
    }
  };

  const closeAll = () => {
    openId.value = null;
  };

  return { isOpen, toggle, closeAll };
}
